/** Inactivity (ms) before checking server contentHash against session baseline. */
export const CHAPTER_STALE_SESSION_INACTIVITY_MS = 30 * 60 * 1000
